import React, { useState } from "react";
import {
  Typography,
  Box,
  Collapse,
  Avatar,
  Button,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  Speed,
  AccountTree,
  ShoppingCart,
  ShoppingBasket,
  Summarize,
  MonetizationOn,
  Key,
  PieChart,
  Report,
  ExpandMore,
  ExpandLess,
  Logout,
  PeopleAlt,
  Home,
  PointOfSale,
  RequestQuote,
  AccountBalance,
  AccountBalanceWallet
} from "@mui/icons-material";
import { useThemes } from "../Theme/theme";
import { useDispatch } from "react-redux";
import { skipReset } from "../../redux/reducers/companySkipSave";
import { logoutStart, logOutStop } from "../../redux/reducers/logout";
import { logOut } from "../../redux/reducers/login";
import { Auth } from "aws-amplify";
import { persistor } from "../../redux/store";
import axios from "axios";
import API_ENDPOINTS from "../../apiEndpoints";
function SidebarDrawer({ sidebarOpen, setSidebarOpen }) {
  const dispatch = useDispatch();

  let logOutFn = async () => {
    let accessToken = null;
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (
        key.startsWith("CognitoIdentityServiceProvider") &&
        key.endsWith(".accessToken")
      ) {
        accessToken = localStorage.getItem(key);
        break;
      }
    }
    try {
      if (accessToken) {
        const option = {
          method: "POST",
          url: API_ENDPOINTS.REACT_APP_GLOBAL_SIGNOUT_URL,
          headers: { Authorization: accessToken },
        };
        await axios(option);
      }

      dispatch(skipReset());
      dispatch(logoutStart());

      localStorage.clear();
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie =
          name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      }
      await Auth.signOut();
      localStorage.clear();
      persistor.purge();
      dispatch(logOut());

      dispatch(logOutStop());
      localStorage.removeItem("emailID");
      localStorage.removeItem("mobileNo");
    } catch (error) {
      console.log(error);
      await Auth.signOut();
      dispatch(logOut());
      dispatch(logOutStop());
      window.location.reload();
    }
  };
  const navigate = useNavigate();
  const [state, setState] = useState({
    selectMenu: "",
    selectSubMenu: "",
    openMenu: {
      dashboard: false,
      inventory: false,
      customer: false,
      purchase: false,
      sales: false,
      expenses: false,
      income: false,
      accounts: false,
      reports: false,
      issue: false,
      pos:false,
      payments:false,
      debitNote:false,
      creditNote:false,
    },
  });
  const { theme } = useThemes();
  const menus = [
    {
      menu: "dashboard",
      title: "DashBoard",
      icon: (
        <Home
          className="icon"
          sx={{
            color:
              state.openMenu.dashboard && state.selectMenu == "dashboard"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [],
      nav: "/",
    },
    {
      menu: "inventory",
      title: "Inventory & items",
      icon: (
        <AccountTree
          className="icon"
          sx={{
            color:
              state.openMenu.inventory && state.selectMenu == "inventory"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [
        {
          name: "List of Items",
          nav: "/newItemList",
        },
        {
          name: "Add Item",
          nav: "/additem",
        },
      ],
    },
    {
      menu: "customer",
      title: "Customer & Supplier",
      icon: (
        <PeopleAlt
          className="icon"
          sx={{
            color:
              state.openMenu.customer && state.selectMenu == "customer"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [
        {
          name: "List of Customers",
          nav: "/customerList",
        },
        {
          name: "Add Customer",
          nav: "/addcustomer",
        },
        {
          name: "List of Suppliers",
          nav: "/supplierList",
        },
        {
          name: "Add Supplier",
          nav: "/addsupplier",
        },
      ],
    },
    {
      menu: "sales",
      title: "Sales Invoices",
      icon: (
        <ShoppingBasket
          className="icon"
          sx={{
            color:
              state.openMenu.sales && state.selectMenu == "sales"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [
        {
          name: "List of Sales",
          nav: "/salesInvoiceReport",
        },
        {
          name: "Add Sales",
          nav: "/addnewinvoicetax",
        },
        // {
        //   name: "Invoice Taxable",
        //   nav: "/invoiceTaxable",
        // },
        // {
        //   name: "Invoice Non-Taxable",
        //   nav: "/invoiceNonTaxable",
        // },
        // {
        //   name: "POS",
        //   nav: "/allpos",
        // },
      ],
    },
    {
      menu: "pos",
      title: "Pos",
      icon: (
        <PointOfSale
          className="icon"
          sx={{
            color:
              state.openMenu.pos && state.selectMenu == "pos"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [
        {
          name: "List of Pos",
          nav: "/allpos",
        },
        {
          name: "Add Pos",
          nav: "/newpos",
        },
        // {
        //   name: "Invoice Taxable",
        //   nav: "/invoiceTaxable",
        // },
        // {
        //   name: "Invoice Non-Taxable",
        //   nav: "/invoiceNonTaxable",
        // },
        // {
        //   name: "POS",
        //   nav: "/allpos",
        // },
      ],
    },
    {
      menu: "income",
      title: "Income/Receipts",
      icon: (
        <MonetizationOn
          className="icon"
          sx={{
            color:
              state.openMenu.income && state.selectMenu == "income"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [
        {
          name:"List of Receipts",
          nav: "/receipts",
        },
        {
          name:"Add Receipt",
          nav: "/addreceipts",
        },

      ],
    },
    {
      menu: "purchase",
      title: "Purchase",
      icon: (
        <ShoppingCart
          className="icon"
          sx={{
            color:
              state.openMenu.purchase && state.selectMenu == "purchase"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [
        {
          name: "List of Purchases",
          nav: "/allpurchaseandexpense",
        },
        {
          name: "Add Purchase",
          nav: "/addnewpurchasetax",
        },

      ],
    },
    {
      menu: "payments",
      title: "Expenses/Payments",
      icon: (
        <Summarize
          className="icon"
          sx={{
            color:
              state.openMenu.payments && state.selectMenu == "payments"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [
        {
          name:"List of Payments",
          nav:"/paymententries"
        },
        {
          name:"Add Payments",
          nav:"/addpaymententries"
        }
      ],
     
    },
    {
      menu: "debitNote",
      title: "Debit Note",
      icon: (
        <RequestQuote
          className="icon"
          sx={{
            color:
              state.openMenu.debitNote && state.selectMenu == "debitNote"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [
        {
          name:"List of Debit Notes",
          nav:"/alldebitnote"
        },
        {
          name:"Add Debit Note",
          nav:"/adddebitnote"
        }
      ],
     
    },
    {
      menu: "creditNote",
      title: "Credit Note",
      icon: (
        <RequestQuote
          className="icon"
          sx={{
            color:
              state.openMenu.creditNote && state.selectMenu == "creditNote"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [
        {
          name:"List of Credit Notes",
          nav:"/allcreditnote"
        },
        {
          name:"Add Credit Note",
          nav:"/addcreditnote"
        }
      ],
     
    },
    {
      menu: "journalentries",
      title: "Journal Entries",
      icon: (
        <Report
          className="icon"
          sx={{
            color:
              state.openMenu.journalentries &&
              state.selectMenu == "journalentries"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [
        {
          name: "List of Journal Entries",
          nav: "/journalentries",
        },
        {
          name: "Add journal entries",
          nav: "/addjournalentry",
        },
      ],
    }, 
    {
      menu: "openingBalance",
      title: "Opening Balance",
      icon: (
        <AccountBalanceWallet
          className="icon"
          sx={{
            color:
              state.openMenu.accounts && state.selectMenu == "openingBalance"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [],
      nav: "/openingbalance",
    },
    {
      menu: "accounts",
      title: "Accounts",
      icon: (
        <Key
          className="icon"
          sx={{
            color:
              state.openMenu.accounts && state.selectMenu == "accounts"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [],
      nav: "/accounts",
    },
    {
      menu: "reports",
      title: "Reports",
      icon: (
        <PieChart
          className="icon"
          sx={{
            color:
              state.openMenu.reports && state.selectMenu == "reports"
                ? theme.palette.primary.main
                : "#00000",
            fontSize: "21px",
          }}
        />
      ),
      submenus: [],
      nav: "/reports",
    },

  ];

  const handleChange = (name) => {
    let obj = {};
    for (const key in state.openMenu) {
      if (key !== name) {
        obj[key] = false;
      }
    }
    setState((prev) => ({
      ...prev,
      selectMenu: name,
      openMenu: {
        ...obj,
        [name]: !state.openMenu[name],
      },
    }));
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100dvh",
        position: "fixed",
        top: 0,
        // left:0,
        left: sidebarOpen ? "0px" : "-100%",
        // background: " rgba(0, 0, 0, 0.5)",
        zIndex: 1000,
        // display:sidebarOpen ? 'block' : 'none',
        visibility: sidebarOpen ? "visible" : "hidden",
        transition: "all 0.1s ease-out",
      }}
      onClick={() => setSidebarOpen(false)}
    >
      <Paper
        sx={{
          width: "300px",
          height: "100%",
          // background: "#fff",
          paddingTop: "60px",
          boxSizing: "border-box",
          transform: sidebarOpen
            ? "translate(0px,0px)"
            : "translate(-250px,0px)",
          transition: "all 0.3s ease-out",
          boxShadow:
            "0px 8px 10px -5px rgb(0 0 0 / 20%), 0px 16px 24px 2px rgb(0 0 0 / 14%), 0px 6px 30px 5px rgb(0 0 0 / 12%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Box
          className="custom-scrollbar"
          sx={{
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {menus.map((item, ind) => {
            return (
              <React.Fragment key={ind}>
                <Box
                  className="boxes"
                  onClick={() => {
                    if (item.nav) {
                      navigate(item.nav);
                      setSidebarOpen(false);
                    } else {
                      handleChange(item.menu);
                    }
                    // handleChange(item.menu)
                  }}
                  sx={{
                    display: "flex",
                    width: "250px",
                    height: "50px",
                    cursor: "pointer",
                  }}
                >
                  <Box
                    sx={{
                      width: "50px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Box
                    sx={{
                      width: "200px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      className="text"
                      sx={{
                        color:
                          state.openMenu[item.menu] &&
                          state.selectMenu == item.menu
                            ? theme.palette.primary.main
                            : "#00000 !important",
                        fontSize: "14px",
                      }}
                    >
                      {item.title}
                    </Typography>
                    {item.submenus.length > 0 &&
                      (state.openMenu[item.menu] ? (
                        <ExpandLess
                          className="toggle_icon"
                          sx={{
                            color: "#00000",
                            fontSize: "21px",
                            marginRight: 1,
                          }}
                        />
                      ) : (
                        <ExpandMore
                          className="toggle_icon"
                          sx={{
                            color: "#00000",
                            fontSize: "21px",
                            marginRight: 1,
                          }}
                        />
                      ))}
                  </Box>
                </Box>
                <Collapse
                  in={
                    state.selectMenu === item.menu && state.openMenu[item.menu]
                  }
                  timeout="auto"
                  unmountOnExit
                >
                  {item.submenus.map((submenu, index) => {
                    return (
                      <Box
                        key={index}
                        onClick={() => {
                          navigate(submenu.nav);
                          setState((prev) => ({
                            ...prev,
                            selectSubMenu: submenu.name,
                          }));
                          setSidebarOpen(false);
                        }}
                        sx={{
                          display: "flex",
                          width: "250px",
                          height: "40px",
                          cursor: "pointer",
                        }}
                      >
                        <Box sx={{ width: "50px" }}></Box>
                        <Box
                          sx={{
                            width: "200px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Avatar
                            children={""}
                            sx={{ width: 6, height: 6, color: "#00000" }}
                          ></Avatar>
                          <Typography
                            className="submenu_text"
                            sx={{
                              paddingLeft: "10px",
                              color:
                                state.selectSubMenu == submenu.name
                                  ? theme.palette.primary.main
                                  : "#00000",
                              fontSize: "14px",
                            }}
                          >
                            {submenu.name}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </Collapse>
              </React.Fragment>
            );
          })}
        </Box>
        <Box sx={{ margin: "0px 15px", borderTop: "solid 1px #b5b5b573" }}>
          <Button
            variant="text"
            startIcon={<Logout />}
            sx={{ color: "#00000" }}
            onClick={() => {
              logOutFn();
            }}
          >
            Logout
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default SidebarDrawer;
